import { Header, Shared, HomePage } from "./language-map";

const languageTR = {
  ...Header,
  ...Shared,
  ...HomePage,
};

export default languageTR;
